import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PhoneShell from "../components/PhoneShell";

const PaymentCancel = () => {
    const nav = useNavigate();
    const { slug } = useParams();
    return (
        <PhoneShell>
            <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center gap-4">
                <div className="font-display font-black text-3xl">Payment cancelled</div>
                <div className="text-[#8C7A72]">No worries — your cart is still saved.</div>
                <button
                    data-testid="cancel-back-btn"
                    onClick={() => nav(`/${slug}/cart`)}
                    className="mt-4 px-8 py-4 rounded-full bg-[#FF4F18] text-white font-display font-bold"
                >
                    Back to cart
                </button>
            </div>
        </PhoneShell>
    );
};

export default PaymentCancel;
